// contactsReducer.js
import produce from "immer";
import {
  UPDATE_CONTACT,
  FETCH_CONTACTS_SUCCESS,
  FETCH_CONTACTS_FAILURE,
  UPDATE_CONTACTS,
  IOS_PRV_MESSAGES,
  IOS_PRV_TYPING,
  ONLINE_USERS,
  SELECTED_CONTACT,
  CONTACT_REFRESH,
  SELECTED_CHAT,
  SET_SNACKBAR,
  USER_DETAIL,
  PRESENT_SCREEN,
  SEND_MESSAGE,
  HANDLE_CALL,
  EDIT_MESSAGE,
  EDIT_MESSAGE_TEXT_SUCCESS,
  CHAT_CLICKED_IN_CALL,
  SET_CALL_USER,
  IN_CALL,
  CHAT_OPEN,
  PENDING_CHATS,
} from "./actionTypes";

const initialState = {
  contacts: [],
  onlineUsers: [],
  messages: [],
  newMessage: {},
  isTyping: {},
  selectedChat: null,
  snackbarState: {
    open: false,
    message: "",
    severity: "",
  },
  userDetail: {},
  handleCall: { type: null },
  chatClickedInCall: null,
  chatOpen: false,
  editMessage: null,
  editedMessageText: null,
  loading: false,
  error: null,
  presentScreen: "Messages",
  callUser: null,
  inCall: false,
  contactsRefresh: null,
  pendingChats: 5,
  RequestSentCount: 0,
  RequestReceivedCount: 0,
};

const BuzzcomReducer = produce((state, action) => {
  console.log("triggered", state, action);
  switch (action.type) {
    case FETCH_CONTACTS_SUCCESS:
      state.contacts = action.payload;
      break;
    case SEND_MESSAGE:
      state.newMessage = action.payload;
      break;
    case EDIT_MESSAGE:
      state.editMessage = action.payload;
      break;
    case EDIT_MESSAGE_TEXT_SUCCESS:
      state.editedMessageText = action.payload;
      break;
    case IOS_PRV_TYPING:
      state.isTyping = action.payload;
      break;
    case ONLINE_USERS:
      state.onlineUsers = action.payload;
      break;
    case SELECTED_CHAT:
      state.selectedChat = action.payload;
      break;
    case PRESENT_SCREEN:
      state.presentScreen = action.payload;
      break;
    case CONTACT_REFRESH:
      state.contactRefresh = action.payload;
      break;
    case SET_SNACKBAR:
      state.snackbarState = action.payload;
      break;
    case CHAT_OPEN:
      state.chatOpen = action.payload;
      break;
    case USER_DETAIL:
      state.userDetail = action.payload;
      break;
    case UPDATE_CONTACTS:
      state.contacts = action.payload;
      break;
    case HANDLE_CALL:
      state.handleCall = action.payload;
      break;
    case SET_CALL_USER:
      state.callUser = action.payload;
      break;
    case CHAT_CLICKED_IN_CALL:
      state.chatClickedInCall = action.payload;
      break;
    case IN_CALL:
      state.inCall = action.payload;
      break;
    case PENDING_CHATS:
      state.pendingChats = action.payload;
      break;
    default:
      return state;
  }
}, initialState);

export default BuzzcomReducer;
